import { LogisticsElement } from 'components/TemplateEditor/slateTypes';

function logisticsSerializer(logisticsElement: LogisticsElement) {
  const { preText } = logisticsElement;
  return `{{#logistics}}${encodeURIComponent(preText)}{{/logistics}}`;
}

export default logisticsSerializer;
